enum LeadResultType {
  BadLead,
  Booked,
  ExistingPatient,
  OtherProcedures,
  NotReached,
  MedicalEscalation,
  DoNotCall,
  DroppedChat
}

export default LeadResultType;
